document.addEventListener('DOMContentLoaded', function() {
  const popups = document.querySelectorAll('.age-verification-popup');

  popups.forEach(function(popup) {
    popup.style.display = 'none';
    popup.style.opacity = '0';

    initAgeVerificationPopup(popup);
  });

  function initAgeVerificationPopup(popup) {
    const cookieName = 'age_verified';
    const testMode = popup.dataset.testMode === 'true';
    const hasVerified = getCookie(cookieName) === 'true';

    const content = popup.querySelector('[data-age-verification-popup-content]');
    const declineContent = popup.querySelector('[data-age-verification-popup-decline-content]');
    const exitButtons = popup.querySelectorAll('[data-age-verification-popup-exit-button]');
    const declineButton = popup.querySelector('[data-age-verification-popup-decline-button]');
    const returnButton = popup.querySelector('[data-age-verification-popup-return-button]');

    if (hasVerified && !testMode) {
      return;
    }

    showPopupWithAnimation();

    if (exitButtons && exitButtons.length > 0) {
      exitButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          hidePopupWithAnimation();

          if (!testMode) {
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + 30);
            document.cookie = `${cookieName}=true;path=/;expires=${expirationDate.toUTCString()}`;
          }
        });
      });
    }

    if (declineButton) {
      declineButton.addEventListener('click', function(e) {
        e.preventDefault();
        showDeclineContent();
      });
    }

    if (returnButton) {
      returnButton.addEventListener('click', function(e) {
        e.preventDefault();
        hideDeclineContent();
      });
    }

    function showPopupWithAnimation() {
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        popup.style.opacity = '1';
        const overlay = popup.querySelector('.age-verification-popup__overlay');
        if (overlay) {
          overlay.style.opacity = '1';
          overlay.style.transform = 'scale(1)';
        }
      }, 10);
    }

    function hidePopupWithAnimation() {
      popup.style.opacity = '0';
      const overlay = popup.querySelector('.age-verification-popup__overlay');
      if (overlay) {
        overlay.style.opacity = '0';
        overlay.style.transform = 'scale(1.02)';
      }
      setTimeout(function() {
        popup.style.display = 'none';
        document.body.style.overflow = '';
      }, 500);
    }

    function showDeclineContent() {
      content.style.opacity = '0';
      setTimeout(function() {
        content.classList.remove('age-verification-popup__content--active');
        content.classList.add('age-verification-popup__content--inactive');

        declineContent.classList.remove('age-verification-popup__content--inactive');
        declineContent.classList.add('age-verification-popup__content--active');

        setTimeout(function() {
          declineContent.style.opacity = '1';
        }, 10);
      }, 300);
    }

    function hideDeclineContent() {
      declineContent.style.opacity = '0';
      setTimeout(function() {
        declineContent.classList.remove('age-verification-popup__content--active');
        declineContent.classList.add('age-verification-popup__content--inactive');

        content.classList.remove('age-verification-popup__content--inactive');
        content.classList.add('age-verification-popup__content--active');
        setTimeout(function() {
          content.style.opacity = '1';
        }, 10);
      }, 300);
    }
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', function(event) {
      const sectionId = event.detail.sectionId;
      const popup = document.querySelector(`[data-section-id="${sectionId}"]`);

      if (popup && popup.classList.contains('age-verification-popup')) {
        popup.style.display = 'block';
        setTimeout(function() {
          popup.style.opacity = '1';
        }, 10);
      }
    });

    document.addEventListener('shopify:section:deselect', function(event) {
      const sectionId = event.detail.sectionId;
      const popup = document.querySelector(`[data-section-id="${sectionId}"]`);

      if (popup && popup.classList.contains('age-verification-popup')) {
        popup.style.opacity = '0';
        setTimeout(function() {
          popup.style.display = 'none';
        }, 500);
      }
    });
  }
});
